import React from 'react';
import { motion } from 'framer-motion';
import { DoubleCheck } from './Icons';
export const Problem = () => {
  return <section className="py-12 md:py-24 bg-brand-darker relative border-y border-white/5" data-id="element-127">
      <div className="max-w-5xl mx-auto px-4" data-id="element-128">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-130">
            <img src="https://cdn.magicpatterns.com/uploads/kTpwcYXd6ZoHfJMBYrbrVg/private_openrouter-generated-image-1777439506289.png" alt="Hombre ansioso mirando el celular" className="w-full max-w-xs mx-auto md:max-w-none h-auto object-cover border border-brand-blue/20 shadow-glow-blue grayscale hover:grayscale-0 transition-all duration-700" data-id="element-131" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-4 md:space-y-6" data-id="element-132">
            <DoubleCheck className="w-8 h-8 md:w-12 md:h-12 text-brand-blue opacity-50 mb-2 md:mb-6" data-id="element-133" />

            <h3 className="font-display text-3xl md:text-5xl text-white uppercase leading-none" data-id="element-134">
              La Morgue <span className="text-brand-blue" data-id="element-135">Digital</span>
            </h3>

            <div className="space-y-3 md:space-y-4 text-brand-light text-base md:text-lg leading-relaxed" data-id="element-136">
              <p data-id="element-137">
                Estás mirando la pantalla. El doble check azul brilla, pero no
                hay respuesta. Pasan las horas y la ansiedad te carcome el
                pecho. Revisas si está "en línea", analizas su última conexión y
                te preguntas:{' '}
                <span className="italic text-white" data-id="element-138">"¿Qué hice mal?"</span>.
              </p>
              <p data-id="element-139">
                Ese silencio es una declaración de poder. Mientras tú esperas,
                la otra persona sabe que te tiene en la palma de su mano. Estás
                en la "Morgue Digital", y cada mensaje de "hola" o "estás ahí?"
                que envías es un clavo más en el ataúd de su interés por ti.
              </p>
              <div className="p-4 md:p-6 bg-brand-dark border border-brand-red/30 mt-4 md:mt-8 relative overflow-hidden" data-id="element-140">
                <div className="absolute top-0 left-0 w-1 h-full bg-brand-red" data-id="element-141"></div>
                <p className="font-medium text-white text-sm md:text-base" data-id="element-142">
                  El problema no es que no le gustes. El problema es que tu
                  atención perdió su valor. Te has vuelto predecible, disponible
                  y, por lo tanto, aburrido.
                </p>
              </div>
              <p className="text-brand-gray text-sm md:text-base" data-id="element-143">
                En México, el juego del ligue es de estatus. Cuando te dejan en
                visto, te están bajando el precio. Intentar "arreglarlo" con
                explicaciones, memes de desesperación o reclamos
                pasivo-agresivos solo confirma lo que ellos ya sospechan: que no
                tienes nada mejor que hacer que esperar a que te contesten.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};